import { Templet1 } from "./templates/templet1";

function Page() {
  return (
    <>
      <Templet1
        headline="Bredband för hållbarhet"
        images="/media/1500/landskap.png"
        textbody={[
          <p>
            <strong>
              Bredband för hållbarhet: En nyckel till den gröna omställningen
            </strong>
            <br />
            Hur kan digital infrastruktur möjliggöra klimatmålen? I rapporten
            "Bredband för hållbarhet" slutredovisar Bredbandsforum arbetet med
            fokusområdet och visar hur bredbandsutbyggnad och digitalisering
            inte bara är tekniska framsteg, utan avgörande verktyg för att bygga
            ett hållbart samhälle.
          </p>,
          <p>
            Rapporten är resultatet av ett tvåårigt arbete där Bredbandsforums
            kansli tillsammans med experter och samhällsaktörer har undersökt
            sambandet mellan digitalisering, bredband och hållbarhet. Genom
            internationella utblickar, intervjuer med offentlig sektor och
            näringsliv, samt konkreta exempel från energisektorn visar rapporten
            hur bredband inte bara är en teknisk förutsättning, utan en
            möjliggörare för klimatmål, energieffektivisering och hållbar
            samhällsutveckling.
          </p>,
        ]}
        cardtitle="DOKUMENT"
        carddata={[
          {
            textbody: (
              <a
                // data-udi="umb://media/e501efcd70094cfba173fc3dc2a75b2c"
                href="/media/1500/Bredbandsforum - Bredband för hållbarhet - 3 juni 2025.pdf"
                title="Bredband för hållbarhet - Slutrapport"
              >
                Bredband för hållbarhet - Slutrapport (PDF)
              </a>
            ),
          },
        ]}
      />
    </>
  );
}
export default Page;
